<template>
  <div></div>
</template>
<script>
export default {
  data() {
    return {
      basic_url: Config.dev_url,
    }
  },
  methods: {
    //检修计划子表汇总按钮
    fixSum(item, childSelectData) {
      var data = {
        year: this.$store.state.detailInfo.year,
        month: this.$store.state.detailInfo.month,
        deptcode: this.$store.state.detailInfo.deptcode,
        plannum: this.$store.state.detailInfo.plannum
      }
      this.$axios.post(Config.dev_url + '/api-apps/app/fixplanApp/operate/workshopFixPlan', data).then(res => {
        if (res.data.resp_code == 0) {
            //子表刷新
          this.$store.commit('setisrequestChildTableData', true)
          this.$message.success(res.data.resp_msg);
        } else {
          this.$message.warning(res.data.resp_msg);
        }
      }).catch((wrong) => {
      })
    }
  }
}
</script>